import { waitForJQuery } from "../../common/jquery-waiter";
export class GeneralComposer {
    showFilters(filterGroup) {
        if (filterGroup.filters.length === 0) {
            return;
        }
        document
            .querySelectorAll(`template.filter-group.filter-type-${filterGroup.filterType}`)
            .forEach((template) => {
            const templateFragment = document.importNode(template.content, true);
            const groupWrapper = this.getGroupWrapper(templateFragment, filterGroup);
            const hiddenFiltersTemplate = templateFragment.querySelector("template.hidden-filter-wrapper");
            const maxVisible = hiddenFiltersTemplate === null
                ? filterGroup.filters.length
                : parseInt(hiddenFiltersTemplate.dataset.maxVisible);
            const visibleFiltersElements = this.createVisibleFiltersElements(filterGroup, maxVisible, templateFragment);
            const anchor = groupWrapper?.querySelector(".js-filters-anchor");
            if (anchor) {
                anchor.after(...visibleFiltersElements);
            }
            const hiddenFiltersElements = this.createHiddenFiltersElements(maxVisible, filterGroup, templateFragment);
            if (hiddenFiltersElements.length > 0) {
                const hiddenFrament = document.importNode(hiddenFiltersTemplate.content, true);
                hiddenFrament.childNodes.forEach((node) => {
                    if (node instanceof HTMLElement) {
                        node.innerHTML = node.innerHTML.replace(/%filterType%/g, filterGroup.filterType);
                        for (const attribute of node.attributes) {
                            node.setAttribute(attribute.name, attribute.value.replace(/%filterType%/g, filterGroup.filterType));
                        }
                    }
                });
                hiddenFrament
                    .querySelector(".js-filter-anchor")
                    .after(...hiddenFiltersElements);
                const showMoreLink = hiddenFrament.querySelector(".js-show-more");
                showMoreLink.addEventListener("click", (event) => {
                    const link = event.target;
                    if (link.classList.contains("collapsed")) {
                        link.classList.remove("collapsed");
                    }
                    else {
                        link.classList.add("collapsed");
                    }
                });
                groupWrapper
                    .querySelector(".js-hidden-filters-anchor")
                    .after(hiddenFrament);
            }
            const groupAnchorId = template.dataset.anchorIdTemplate?.replace(/%filterType%/g, filterGroup.filterType);
            const groupAnchor = document.getElementById(groupAnchorId);
            if (groupAnchor) {
                groupAnchor.after(groupWrapper);
            }
            else {
                template.after(groupWrapper);
            }
            waitForJQuery(() => {
                if (groupWrapper.classList.contains("select2")) {
                    $(groupWrapper).select2();
                }
                $(groupWrapper).find(".select2").select2();
            });
        });
    }
    getGroupWrapper(templateFragment, filterGroup) {
        const groupWrapper = templateFragment.querySelector(".filter-group");
        if (!groupWrapper) {
            return null;
        }
        groupWrapper.innerHTML = groupWrapper.innerHTML.replace(/%groupName%/g, filterGroup.name);
        return groupWrapper;
    }
    createHiddenFiltersElements(maxVisible, filterGroup, templateFragment) {
        const hiddenFiltersElements = [];
        for (let i = maxVisible; i < filterGroup.filters.length; i++) {
            const filter = filterGroup.filters[i];
            const filterElement = this.createFilter(templateFragment, filter);
            if (!filterElement) {
                continue;
            }
            hiddenFiltersElements.push(filterElement);
        }
        return hiddenFiltersElements;
    }
    createVisibleFiltersElements(filterGroup, maxVisible, templateFragment) {
        const visibleFiltersElements = [];
        for (let i = 0; i < Math.min(filterGroup.filters.length, maxVisible); i++) {
            const filter = filterGroup.filters[i];
            const filterElement = this.createFilter(templateFragment, filter);
            if (!filterElement) {
                continue;
            }
            visibleFiltersElements.push(filterElement);
        }
        return visibleFiltersElements;
    }
    createFilter(templateFragment, filter) {
        const status = filter.checked ? "checked" : "unchecked";
        const filterFragment = document.importNode(templateFragment.querySelector("template.js-filter")
            .content, true);
        const filterElement = filterFragment.querySelector(`.js-${status}`);
        if (!filterElement) {
            return null;
        }
        filterElement.innerHTML = filterElement.innerHTML
            .replace(/%filterName%/g, filter.value)
            .replace(/%filterUrl%/g, filter.url)
            .replace(/%filterNumber%/g, filter.number.toString());
        for (const attribute of filterElement.attributes) {
            filterElement.setAttribute(attribute.name, attribute.value
                .replace(/%filterName%/g, filter.value)
                .replace(/%filterUrl%/g, filter.url)
                .replace(/%filterNumber%/g, filter.number.toString()));
        }
        return filterElement;
    }
    isForFilterType(filterType) {
        return true;
    }
    cleanUp() {
        document
            .querySelectorAll("template.filter-group")
            .forEach((template) => {
            document
                .querySelectorAll(template.dataset.skeletonSelector)
                .forEach((skeleton) => {
                skeleton.remove();
            });
        });
    }
}
